import { PropertyHoursOfOperation } from '@/types/Property'

type PropertyHoursFields = keyof PropertyHoursOfOperation
export const officeHourMapping: { close: PropertyHoursFields; label: string; open: PropertyHoursFields }[] = [
  { label: 'Sunday', open: 'sundayOpen', close: 'sundayClose' },
  { label: 'Monday', open: 'mondayOpen', close: 'mondayClose' },
  { label: 'Tuesday', open: 'tuesdayOpen', close: 'tuesdayClose' },
  { label: 'Wednesday', open: 'wednesdayOpen', close: 'wednesdayClose' },
  { label: 'Thursday', open: 'thursdayOpen', close: 'thursdayClose' },
  { label: 'Friday', open: 'fridayOpen', close: 'fridayClose' },
  { label: 'Saturday', open: 'saturdayOpen', close: 'saturdayClose' },
]
